import { render, staticRenderFns } from "./VideoSwiper.vue?vue&type=template&id=51a99e69&scoped=true&"
import script from "./VideoSwiper.vue?vue&type=script&lang=js&"
export * from "./VideoSwiper.vue?vue&type=script&lang=js&"
import style0 from "./VideoSwiper.vue?vue&type=style&index=0&id=51a99e69&prod&lang=postcss&scoped=true&"
import style1 from "./VideoSwiper.vue?vue&type=style&index=1&id=51a99e69&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a99e69",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsEmbed: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsEmbed.vue').default,SwiperNav: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/swiper-nav/SwiperNav.vue').default})
